import { createRoot } from 'react-dom/client';

import { enforceCanonicalOrigin } from 'utils/canonicalOrigin';
import { ensureProjectHostSession } from 'utils/handoff';

import Wrapper from './Wrapper';

// BEFORE anything renders or reads storage. If we are on the wrong
// origin, the session we are about to look for lives in another
// origin's localStorage and will not be found — so redirect first and
// let the canonical origin do the work. `root` stays module-scoped
// because the HMR hook below needs it.
const redirecting = enforceCanonicalOrigin();

// On a project host, the session lives in ANOTHER origin's localStorage
// — collect it (or go and ask for it) before anything looks for one.
// Resolves immediately when there is nothing to do, which is every load
// on the console and every subsequent load on a project host.
const root = redirecting ? null : createRoot(document.getElementById('root'));

if (!redirecting) {
  ensureProjectHostSession()
    .then((waiting) => {
      if (!waiting) {
        root.render(<Wrapper />);
      }
    })
    .catch(() => root.render(<Wrapper />));
}

if (import.meta.hot) {
  // HMR re-renders the entire tree here. This is
  // only needed in Vite because it's not .jsx
  // If this wasn't here HMR would perform a full
  // page reload. This is much faster but note it
  // does still re-render the entire React root.
  import.meta.hot.accept('./Wrapper.js', (newModule) => {
    const NextWrapper = newModule.default;
    root?.render(<NextWrapper />);
  });
}
